export const API_URL = 'https://chat-service-be-1004368012096.asia-south1.run.app/api'
export const SOCKET_URL = 'https://chat-service-be-1004368012096.asia-south1.run.app'